import React from 'react';
import { Button, CREATE, refreshView, useNotify, useDataProvider } from 'react-admin';
import IconCheckBox from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';
import { useDispatch } from 'react-redux';

const BusinessContractStatusButton = ({ record }) => {
	const dataProvider = useDataProvider();
	const dispatch = useDispatch();
	const notify = useNotify();

	const toggleStatus = () => {
		dataProvider(CREATE, 'businessContracts', {
			id: record.id,
			method: record.status === 'Active' ? 'deactivate' : 'activate'
		})
			.then(() => {
				notify(record.status === 'Active' ? 'resources.businessContracts.notifications.deactivated' : 'resources.businessContracts.notifications.activated');
				dispatch(refreshView());
			})
			.catch(error => {
				notify(error.message, 'error');
			});
	};

	return (
		<Button
			onClick={toggleStatus}
			label={record.status === 'Active' ? 'resources.businessContracts.labels.deactivateButton' : 'resources.businessContracts.labels.activateButton'}
			variant="text"
		>
			{record && record.status === 'Active' ?  <IconCheckBox /> : <CheckBoxOutlineBlank />}
		</Button>
	);
};

export default BusinessContractStatusButton;
